import { call, all, put, takeLatest, select } from 'redux-saga/effects';

import { UserInterface } from '@e3labs/isa-data-dictionary';

import { GET_ALL_REQUEST, GET_RECOMMENDATION_REQUEST } from './sales-tracking-constants';

import salesTrackingService from './sales-tracking-service';

import * as salesTrackingActions from './sales-tracking-actions';

import { ISA_ERROR } from '~/constants';

import { insertId } from './sales-tracking-utils';
import { AppStateType } from '../root-reducer';

export function* getAll() {
  try {
    yield put(salesTrackingActions.setLoadingData(true));

    const { data: indicators } = yield call(salesTrackingService.getAllIndicators);

    if (indicators?.length > 0) {
      let data = insertId(indicators[0]);
      data.dateTime = new Date();

      yield put(salesTrackingActions.getAllSuccess(data));
    }

    yield put(salesTrackingActions.setLoadingData(false));
  } catch (error) {
    yield put(salesTrackingActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* getRecommendation({ payload }: any) {
  const user: UserInterface = yield select((state: AppStateType) => state.auth.user);

  try {
    yield put(salesTrackingActions.setLoadingRecommendation(true));

    const { data: recommendation } = yield call(salesTrackingService.getRecommendation, {
      entityExternalCode: payload?.externalCode,
      entity: payload?.entity,
      userExternalCode: user?.externalCode
    });

    yield put(salesTrackingActions.getRecommendationSuccess(recommendation));
    yield put(salesTrackingActions.setLoadingRecommendation(false));
  } catch (error) {
    yield put(salesTrackingActions.setLoadingRecommendation(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export default all([takeLatest(GET_ALL_REQUEST, getAll), takeLatest(GET_RECOMMENDATION_REQUEST, getRecommendation)]);
